// This example controller works with specially annotated HTML like:
//
//  <div data-controller="nested-form">
//    <template data-nested-form-target="template">
//      <%= form.fields_for :tasks, Task.new, child_index: 'NEW_RECORD' do |ff| %>
//        <%= render "task_fields", form: ff %>
//      <% end %>
//    </template>
//    <%= form.fields_for :tasks do |ff| %>
//      <%= render "task_fields", form: ff %>
//    <% end %>
//    <%= link_to "Add Task", "#", "data-nested-form-target": "link", "data-action": "click->nested-form#addAssociation" %>
//  </div>
//
//  # _task_fields.html.erb
//  <div class="nested-fields" data-new-record="<%= form.object.new_record? %>">
//    <%= form.text_field :name %>
//    <%= link_to "Remove", "#", "data-action": "click->nested-form#removeAssociation" %>
//    <%= form.hidden_field :_destroy %>
//  </div>

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["link", "template", "focusable"]
  }

  addAssociation(e) {
    if (e) {
      e.preventDefault()
    }
    let content = this.templateTarget.innerHTML.replace(
      /NEW_RECORD/g,
      new Date().getTime()
    )
    this.linkTarget.insertAdjacentHTML("beforebegin", content)
    // No Turbo event fires for a row inserted here, so FlyonUI components inside it
    // would stay uninitialized. autoInit skips what it already holds.
    window.HSStaticMethods.autoInit()
    if (this.hasFocusableTarget) {
      this.focusableTargets.slice(-1)[0].focus()
    }
  }

  addAssociationOnEnter(e) {
    if (e.key === "Enter") {
      e.preventDefault()
      this.addAssociation(e)
    }
  }

  removeAssociation(e) {
    e.preventDefault()
    let wrapper = e.target.closest(".nested-fields")
    if (
      wrapper.dataset.newRecord === "true" ||
      wrapper.dataset.withoutId === "true"
    ) {
      wrapper.remove() // New records are simply removed from the page
    } else {
      // Existing records are hidden and flagged for deletion
      wrapper.querySelector("input[name*='_destroy']").value = 1
      wrapper.style.display = "none"
    }
  }
}
